<template>
  <div class="navbar-container">
    <nav class="navbar flex justify-between items-center h-full w-full px-200 mx-auto gap-200">
      <slot />
    </nav>
  </div>
</template>

<style lang="scss" scoped>
.navbar-container {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 50;
  grid-row: 3;
  width: 100%;
  height: $main-bottom-navigation-height;
  background-color: token('color/background/primary/primary');
  box-shadow: token('shadow/shadow/card/large');

  .navbar {
    max-width: $main-content-width;
  }
}
</style>
